import type { SVGProps } from 'react';

import styles from './GitBookLoader.module.css';

export function GitBookLoader(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={48}
            height={44}
            viewBox="0 0 48 44"
            aria-busy="true"
            {...props}
        >
            <defs>
                <linearGradient
                    id="gitbook-loader-gradient"
                    gradientUnits="userSpaceOnUse"
                    x1={0.999999}
                    y1={43.4239}
                    x2={46.9957}
                    y2={1.27728}
                >
                    <stop offset="0%" stopColor="#F2F7F7" />
                    <stop offset="33%" stopColor="#CBC0D9" />
                    <stop offset="66%" stopColor="#E3858D" />
                    <stop offset="100%" stopColor="#F1E6E5" />
                </linearGradient>
            </defs>
            <path
                className={styles.animatePath}
                d="M20.3742 23.1859C22.6233 24.4918 23.7478 25.1448 24.9828 25.1459C26.2177 25.147 27.3434 24.496 29.5947 23.194L43.9456 14.8946C44.5935 14.52 44.9929 13.8255 44.9929 13.0737C44.9929 12.3219 44.5935 11.6274 43.9456 11.2527L29.5895 2.95038C27.3406 1.6498 26.2162 0.999516 24.9824 1C23.7486 1.00048 22.6247 1.65165 20.3768 2.95399L8.03536 10.1042C7.94389 10.1572 7.89815 10.1836 7.85553 10.2087C3.63979 12.6916 1.03518 17.2245 1.00035 22.139C1 22.1886 1 22.2417 1 22.3479C1 22.454 1 22.507 1.00035 22.5567C1.0351 27.4656 3.63391 31.9942 7.84213 34.4791C7.88468 34.5042 7.93033 34.5307 8.02163 34.5837L15.7522 39.0743C20.2569 41.6909 22.5092 42.9992 24.9826 43C27.456 43.0009 29.7092 41.6941 34.2156 39.0805L42.3763 34.3475C44.6327 33.0389 45.761 32.3845 46.3805 31.3058C47 30.2271 47 28.9169 47 26.2966V21.2347C47 20.5078 46.6087 19.8379 45.9774 19.4842C45.3666 19.1419 44.622 19.147 44.0159 19.4975L27.2821 29.1749C26.1594 29.8242 25.5981 30.1489 24.982 30.149C24.366 30.1492 23.8044 29.8249 22.6813 29.1764L11.3555 22.6357C10.7882 22.308 10.5045 22.1442 10.2768 22.1146C9.75731 22.0472 9.25779 22.3399 9.05996 22.8278C8.97319 23.0418 8.97491 23.3708 8.97841 24.029C8.98106 24.5135 8.98234 24.7557 9.02737 24.9786C9.12814 25.4776 9.38909 25.9294 9.7701 26.2646C9.9402 26.4143 10.1488 26.5354 10.5659 26.7776L22.675 33.8089C23.801 34.4627 24.364 34.7897 24.9822 34.7898C25.6005 34.79 26.1637 34.4634 27.29 33.8101L42.1322 25.2026C42.517 24.9795 42.7094 24.868 42.8536 24.9518C42.9978 25.0356 42.9978 25.2591 42.9978 25.7058V28.0018C42.9978 28.6569 42.9978 28.9844 42.8429 29.2542C42.6881 29.5238 42.406 29.6874 41.8418 30.0146L29.6 37.1141C27.3462 38.4211 26.2194 39.0746 24.9825 39.074C23.7455 39.0734 22.6193 38.4189 20.3668 37.1098L8.91344 30.4535C8.87707 30.4324 8.85884 30.4218 8.8419 30.4119C6.44042 29 4.95862 26.4172 4.94472 23.619C4.94462 23.5992 4.94462 23.5781 4.94462 23.5359V21.4282C4.94462 19.8834 5.7624 18.4556 7.09081 17.6809C8.26463 16.9965 9.71257 16.9951 10.8877 17.6774L20.3742 23.1859Z"
                fill="none"
                stroke="url(#gitbook-loader-gradient)"
                strokeWidth={1.666}
                strokeLinecap="round"
            />
        </svg>
    );
}
